// extracted by mini-css-extract-plugin
export default {"sso-logo":"providers_sso-logo__bWQPA","separator":"providers_separator__-JQMC"};